export default __webpack_public_path__ + "static/media/legoffena.6c8eb711.jpg";